import {ActionTree} from 'vuex';
import {HomeState} from "@/module/home/store/home-state";


export const Actions: ActionTree<HomeState, any> = {};
